/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Caption_Style_DescInputs */



/**
* | output |
* | --- |
* | "Change caption style of selected events" |
*
* @param {Caption_Style_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const caption_style_desc = /** @type {((inputs?: Caption_Style_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Caption_Style_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Modifier le style des événements sélectionnés")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ändern Sie den Untertitelstil der ausgewählten Ereignisse")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cambia lo stile della didascalia degli eventi selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Изменить стиль подписи к выбранным событиям")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cambiar el estilo de subtítulos de los eventos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("更改所选事件的标题样式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントのキャプションスタイルを変更する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित इवेंट्स के कैप्शन स्टाइल बदलें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alterar o estilo da legenda dos eventos selecionados")
	return /** @type {LocalizedString} */ ("Change caption style of selected events")
});